import { ErrorSummryVariableToBeConsider } from "./data";

export const getProgressValueForUpload = (status: string) => {
  switch (status) {
    case 'pending':
      return 50;
    case 'uploaded':
      return 75;
    case 'completed':
      return 100;
    default:
      return 0;
  }
};

declare global {
  interface Window {
    upro: {};
  }
}

export const updateWindowUpro = (config: Record<string, any>) => {
  if (window.upro) {
    /* If upro already exists, append the keys/values from the config object */
    Object.assign(window.upro, config);
  } else {
    /* If upro doesn't exist, initialize it with the config values */
    window.upro = {
      ...config,
      name: 'upro',
    };
  }
};

export const orderSummaryDataTransformation = (
  columns: { identifierID: string; columnName: string }[],
  tabledata: Record<string, string>[],
): Record<string, any>[] => {
  const columnMap = new Map(columns.map(({ identifierID, columnName }) => [identifierID, columnName]));

  const transformedData = tabledata.map(row =>
    Object.fromEntries(
      Object.entries(row).map(([key, value]) => [columnMap.get(key) ?? key, value])
    )
  );

  return transformedData;
};

export const getColumnNameByIdentifier = (
  identifier: string,
  columnsList: { identifier: string; columnName: string }[],
): string | null => {
  const columnMap = new Map(columnsList.map(col => [col.identifier, col.columnName]));
  return columnMap.get(identifier) ?? null;
};


export const getSafeNumber = (obj: any, key: string, defaultValue: number) => {
  return obj?.[key] !== undefined && obj?.[key] !== ''
    ? Number(obj[key])
    : defaultValue;
};

export const getColumnHeadings = (
  tableData: Record<string, string>[],
  columns: { columnName: string; isShowInOrderSummary?: boolean; priority?: number }[],
): string[] => {
  if (!tableData.length) return [];

  const columnMap = new Map(columns.map(col => [col.columnName, col]));

  const b = Object.keys(tableData[0])
    .filter(key => columnMap.get(key)?.isShowInOrderSummary ?? (key !== "Is Error" && key !== "Error"))
    .sort((a, b) => (columnMap.get(a)?.priority ?? Infinity) - (columnMap.get(b)?.priority ?? Infinity));

    return b;
};

export const getErrorSummaryVariable = (
  columns: { identifier: string; columnName: string; isShowInOrderSummary?: boolean; priority?: number }[]
) => {
  if (!columns) return '';
  
  const columnMap = new Map(columns.map(col => [col.identifier, col]));
  

  for (const key of ErrorSummryVariableToBeConsider) {
    if (columnMap.has(key) && columnMap.get(key)?.isShowInOrderSummary) {
      return columnMap.get(key)?.columnName;
    }
  }
  return '';
}

